import { HttpParams } from '@angular/common/http';
import { Component, HostListener, OnInit, TemplateRef } from '@angular/core';
import { Sort_Utils } from 'src/app/entities/Sort_Utils';
import { Anagrafica, ManagedUsersTable, Utente } from 'src/app/entities/various';
import { LoginService, UserInfo } from 'src/app/services/login/login.service';
import { ConfigServiceService, ItemSidebar, ItemTopbar,ConfigProps } from 'src/app/services/config-service/config-service.service';
import { Router } from '@angular/router';
import { UtenteService } from 'src/app/services/users/utente.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {

  navigator : string = 'sidebar.utenti';
 
  innerWidth: number | undefined;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }

  configProps : ConfigProps | undefined;
  private _generalConfigTopbar : ItemTopbar[] | undefined;
  visibilityUsers: any[] | undefined;
  visibility: number | undefined;
  //activeServices: any[] | undefined;
  services: number | undefined;
  _userConfigTopbar: ItemTopbar[] = [];
  userInfo : UserInfo | undefined;
  managedUsersTable : ManagedUsersTable | undefined;
  params : HttpParams;
  sortUtils : Sort_Utils = new Sort_Utils();
  toastConfig : {title: string, class: string} | undefined;
  pages = [{key : 2},{key : 12}, {key : 25}, {key : 50}, {key : 100}];
  loading :boolean =false;
  utente: Utente;
  condizioni: boolean = false;

  constructor(
    private loginService: LoginService, 
    private configurationService: ConfigServiceService, 
    private utenteService: UtenteService,
    private ngbModal: NgbModal
  ) {
    this.params = new HttpParams();
    this.params =this.params.append('endRow', 0);
    this.params =this.params.append('lastKeyVal', '');
    this.params =this.params.append('page', 1);
    this.params =this.params.append('pageDirection', 'FORWARD');
    this.params =this.params.append('pageSize', 12);
    this.params =this.params.append('pagination', true);
    this.params =this.params.append('paginationMode', 'SKIP');
    this.params =this.params.append('rows', 0);
    this.params =this.params.append('sortDir', 'ASC');
    this.params =this.params.append('sortKey', 'email');
    this.params =this.params.append('startRow', 0);
    this.params =this.params.append('totalPages', -1);
    this.params =this.params.append('totalRows', 0);
    this.params= this.params.append('searchFilter', '{}');
    this.innerWidth = window.innerWidth;
    /*this.activeServices = Array(
        {'val':'0','label':'Tutti'},
        {'val':'1','label':'NSO'},
        {'val':'2','label':'Fatture UBL'},
        {'val':'3','label':'DDT UBL'}
    );*/

    this.utente = {
      user_id: 0,
      email: '',
      is_active: 'f',
      created_at: '',
      last_login: '',
      indirizzo: '',
      comune: '',
      provincia: '',
      cap: '',
      nazione: '',
      denominazione: '',
      codice_fiscale: '',
      partita_iva: '',
      regime_fiscale: '',
      pec: '',
      iban_list: '',
      password_hash: null,
      id_admin: null
    }
   }

  async ngOnInit(): Promise<void> {
    this.userInfo = await this.loginService.getUserInfo();
    this.managedUsersTable = {
      data: [],
      endRow: 0,
      page: "1",
      rows: 0,
      startRow: 1,
      totalPages: 0,
      totalRows: 0
    };

    this.configProps =  await (await this.configurationService.getJSON());
    this._generalConfigTopbar=this.configProps.configTopbar;

    this.visibilityUsers=this.configProps.visibilityUsers;

    //this._generalConfigTopbar = await (await this.configurationService.getJSON()).configTopbar;
    this._generalConfigTopbar=this._generalConfigTopbar.filter(i => i.position=='users');
    
    this._generalConfigTopbar.forEach(c => {
      let check = c.allow.includes(this.userInfo!.role);
      if(check){
        this._userConfigTopbar.push(c);
      }
    });

   // this.configProps = new UTILS().deepCopy(await this.configurationService.getJSON());
    //this.visibility=this.visibilityUsers![0].val;
    //this.services=this.activeServices![0].val;
    this.getTable();
  }

  async sort(key: string){
    this.loading=true;
    this.params =this.params.delete('sortKey');
    this.params =this.params.delete('sortDir');
    this.params =this.params.append('sortKey', key);
    this.params =this.params.append('sortDir', this.sortUtils.getSortDir(key));
    await this.getTable();
    this.loading=false;
  }


  async setPage(newPage:number){
    this.loading=true;
    if(this.params.get('page') != null){
      this.params = this.params.set('page', newPage);
      await this.getTable();
    }
    this.loading=false;
  }
  async prev(){
    this.loading=true;
    if(this.params.get('page') != null){
      let val : number = +this.params.get('page')! - 1;
      this.params = this.params.set('page', val);
      await this.getTable();
    }
    this.loading=false;
  }
  async firstPage(){
    this.loading=true;
    if(this.params.get('page') != null){
      let val : number = 1;
      this.params = this.params.set('page', val);
      await this.getTable();
    }
    this.loading=false;
  }

  async next(){
    this.loading=true;
    if(this.params.get('page') != null){
      let val : number = +this.params.get('page')! + 1;
      this.params = this.params.set('page', val);
      await this.getTable();
    }
    this.loading=false;
  }

  async getTable(){
    if (this.userInfo!.role == '1') {
      this.params= this.params.append('searchFilter', '{\"id_admin\":\"' + this.userInfo?.user_id +'\"}');
    }
    this.loading=true;
    let response = await this.utenteService.ricercaUtente(this.userInfo!.user_id, this.params);
    //let response = await this.userService.getManagedUsersTable(this.userInfo!.dms_user_id, this.params);
    if(response.success){
      
      this.managedUsersTable = response.data;
    }
    this.loading=false;
  }

  async changePageSize (pageSize: number) {
    this.params= this.params.delete('pageSize');
    this.params= this.params.append('pageSize', pageSize);
    this.managedUsersTable = await (await this.utenteService.ricercaUtente(this.userInfo!.user_id, this.params!)).data;
    //this.managedUsersTable = await (await this.userService.getManagedUsersTable(this.userInfo!.dms_user_id, this.params!)).data;
  }


  async changeUserVisibility(hidden: number){
    this.visibility=hidden;
    this.setBaseFilter();
    this.managedUsersTable = await (await this.utenteService.ricercaUtente(this.userInfo!.user_id, this.params!)).data;
    //this.managedUsersTable = await (await this.userService.getManagedUsersTable(this.userInfo!.dms_user_id, this.params!)).data;
  }

  async changeServices(servizio: number){
    this.services=servizio;
    this.setBaseFilter();
    this.managedUsersTable = await (await this.utenteService.ricercaUtente(this.userInfo!.user_id, this.params!)).data;
    //this.managedUsersTable = await (await this.userService.getManagedUsersTable(this.userInfo!.dms_user_id, this.params!)).data;
  }
  async searchByUsername(val : string) {
    this.setBaseFilter();
    this.params= this.params.append('searchFilter', '{\"email\":\"' + val +'\"}');
    this.managedUsersTable = await (await this.utenteService.ricercaUtente(this.userInfo!.user_id, this.params!)).data;
    //this.managedUsersTable = await (await this.userService.getManagedUsersTable(this.userInfo!.dms_user_id, this.params!)).data;

  }

  setBaseFilter(){
    this.params = this.params.set('page', 1);
    this.params= this.params.delete('searchFilter');
    this.params= this.params.delete('confrontoInteri');
    /*if(this.visibility==3)
        this.params= this.params.append('searchFilter','{\"abilitato\":\"' + this.visibility +'\"}');
    else{
          this.params= this.params.append('searchFilter','{\"abilitato\":3}');
          this.params= this.params.append('confrontoInteri','ne');
    }
    if(this.services==1){
        this.params= this.params.append('searchFilter','{\"abilita_nso\":\"1\"}');
    }
    if(this.services==2){
        this.params= this.params.append('searchFilter','{\"abilita_peppol\":\"1\"}');
    }
    if(this.services==3){
        this.params= this.params.append('searchFilter','{\"abilita_ddt\":\"1\"}');
    }*/
  }

  async searchByVat(val : string) {
    this.setBaseFilter();
    //this.params= this.params.append('searchFilter', '{\"json_sdi_data\":\"' + val +'\"}');
    this.managedUsersTable = await (await this.utenteService.ricercaUtente(this.userInfo!.user_id, this.params!)).data;
    //this.managedUsersTable = await (await this.userService.getManagedUsersTable(this.userInfo!.dms_user_id, this.params!)).data;
  }

  getJsonData(u : UserInfo) {
    let jdata : Anagrafica =  JSON.parse(u.json_sdi_data);
    return jdata;

  }

  apriModalRegistrazione(content: TemplateRef<any>) {
    this.ngbModal.open(content, { size: 'lg' });
  }

  async controllaPiva(event: any)
  {
    await this.utenteService.controlloPartitaIva(event.target.value).then(
      (resp) => {
        if (resp.success || resp.data.name != '---') {
          this.utente.denominazione = resp.data.name;
          this.utente.nazione = resp.data.countryCode;
          let indirizzo = ((resp.data.address).replace("\n", '')).split(' ');
          let reversedIndirizzo = [...indirizzo].reverse();
          const [provincia, comune, cap, ...resto] = reversedIndirizzo;
          const indirizzoCompleto = resto.reverse().join(" ");
          this.utente.provincia = provincia;
          this.utente.comune = comune;
          this.utente.cap = cap;
          this.utente.indirizzo = indirizzoCompleto;
        } else {
          console.log("Partita IVA non riconosciuta, inserisci manualmente i campi anagrafici");
        }
      }
    );
    
  }

  setSessionUser(u : Utente) {
    /*this.loginService.setSessionUserInfo(u);
    this.router.navigate(['main/invoices']);*/
  }

  setSessionConfUser(u : Utente) {
    /*this.loginService.setSessionUserInfo(u);
    this.router.navigate(['main/configuration']);*/
  }

  /*setSessionNSOUser(u : UserInfo) {
    if (u.abilita_nso) {
      this.loginService.setSessionUserInfo(u);
      this.router.navigate(['main/orders']);
    }
    
  }

  setSessionPeppolUser(u : UserInfo) {
    if (u.abilita_peppol || u.abilita_ddt) {
      this.loginService.setSessionUserInfo(u);
      this.router.navigate(['main/documenti_ubl']);
    }
  }*/
  forceMainUser(){
    this.loginService.setSessionUserInfo(this.userInfo!);
  }

}


